import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CreateDialogStateService {
  private createDialogStatusSubject = new Subject<any>();

  constructor() { }

  triggerDialogStatus(data: any) {
    this.createDialogStatusSubject.next(data);
  }

  handleDialogStatus(): Observable<any> {
    return this.createDialogStatusSubject.asObservable();
  }

}




// WEBPACK FOOTER //
// ./src/app/components/dashboard/communications/create-dialog-communications/create.dialog.communications.state.service.ts